export default __webpack_public_path__ + "static/media/search.13c92635.svg";